import { defineComponent, onMounted, onUnmounted } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { useInterceptorStore } from '@/store/modules/interceptor';
import { storeToRefs } from 'pinia';
import { getChannelLabel, numberFormat } from '@/utils/helpers';
import { WidgetApiServiceTypes } from '@/types/widgetApiService';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import LoaderComponent from '@/components/general/LoaderComponent.vue';
import { TransactTypes } from '@/types/transact';
import { useAuthStore } from '@/store/modules/auth';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
var TransactionType = TransactTypes.TransactionType;
export default defineComponent({
    name: 'PaymentOptions',
    computed: {
        TransactionType() {
            return TransactionType;
        },
    },
    components: {
        TransactHeader,
        LoaderComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedCrypto, selectedCurrency, channels, loading, currentStep, loadingMessage, channel, selectedChannel, selectedChannelId, loadingErrorMessage, txType, networkFee, activeSupportedCountryConfig, } = storeToRefs(transactionsStore);
        const authStore = useAuthStore();
        const { isLoggedIn, partnerId } = storeToRefs(authStore);
        const interceptorStore = useInterceptorStore();
        const { showBackNavigation } = storeToRefs(interceptorStore);
        onMounted(async () => {
            loading.value = true;
            loadingMessage.value = 'Connecting you to payment providers';
            loadingErrorMessage.value = '';
            try {
                const _channels = await transactionsStore.getChannelsWithFees(txType.value);
                channels.value = _channels.length ? _channels : [];
                // if no channels direct to no channels view
                if (channels.value.length === 0) {
                    currentStep.value = TransactTypes.TransactSteps.NO_CHANNELS;
                    loading.value = false;
                    loadingMessage.value = '';
                    loadingErrorMessage.value = '';
                }
            }
            catch (e) {
                loadingMessage.value = `We're sorry about this.`;
                loadingErrorMessage.value =
                    'A problem occurred trying to load. Please refresh to try again.';
                return;
            }
            if (selectedChannelId.value) {
                const defaultChannel = channels.value.filter(_channel => selectedChannelId.value === _channel.id)[0];
                channel.value = defaultChannel;
                selectedChannel.value = defaultChannel.channelType;
                transactionsStore.setFees();
                currentStep.value = TransactTypes.TransactSteps.BUY_3;
            }
            loading.value = false;
            loadingMessage.value = '';
            loadingErrorMessage.value = '';
        });
        onUnmounted(() => {
            loadingErrorMessage.value = '';
        });
        const onPaymentMethodSelected = async (evt, channelInput) => {
            trackEvent(MIXPANEL_EVENTS.PAYMENT_METHOD, {
                logged_in: isLoggedIn.value,
                partner: partnerId.value,
                payment_method: getChannelLabel(channelInput.channelType),
            });
            loadingMessage.value = 'Preparing order';
            loading.value = true;
            channel.value = channelInput;
            selectedChannel.value = channelInput.channelType;
            transactionsStore.setFees();
            currentStep.value = TransactTypes.TransactSteps.BUY_3;
            loading.value = false;
        };
        const goBack = () => {
            currentStep.value = TransactTypes.TransactSteps.BUY_1;
        };
        const onKeyPress = () => {
            console.log();
        };
        return {
            onKeyPress,
            selectedCrypto,
            numberFormat,
            selectedCurrency,
            onPaymentMethodSelected,
            channels,
            txType,
            WidgetApiServiceTypes,
            loading,
            goBack,
            isLoggedIn,
            networkFee,
            showBackNavigation,
            activeSupportedCountryConfig,
        };
    },
});
